import discoveryService from './discovery-service';

/**
 * Tracks user actions that should trigger discovery algorithm updates
 */
export class ActionTracker {
  /**
   * Track when user adds a new outfit
   */
  static trackOutfitUpload(outfitId: string) {
    console.log('🎯 Action: Outfit uploaded', outfitId);
    // Cache invalidation would be handled by backend
  }

  /**
   * Track when user likes an outfit
   */
  static trackOutfitLike(outfitId: string, liked: boolean) {
    console.log('🎯 Action: Outfit', liked ? 'liked' : 'unliked', outfitId);
    // Cache invalidation would be handled by backend
  }

  /**
   * Track when user follows/unfollows someone
   */
  static trackFollow(userId: string, followed: boolean) {
    console.log('🎯 Action: User', followed ? 'followed' : 'unfollowed', userId);
    // Cache invalidation would be handled by backend
  }

  /**
   * Track when user rates an outfit
   */
  static trackOutfitRating(outfitId: string, rating: number) {
    console.log('🎯 Action: Outfit rated', outfitId, rating);
    // Cache invalidation would be handled by backend
  }
}

export default ActionTracker;